import * as events from "events";
export class ChatEventListenerBase extends events.EventEmitter {
}
export var ChatEvents;
(function (ChatEvents) {
    ChatEvents["SocketInitializedEvent"] = "socket::initialized";
    ChatEvents["SocketConnectedEvent"] = "socket::connected";
    ChatEvents["SocketDisconnectedEvent"] = "socket::disconnected";
    ChatEvents["SocketErrorEvent"] = "socket::error";
    ChatEvents["SocketReconnectedEvent"] = "socket::reconnected";
    ChatEvents["SocketReconnectionTimeoutEvent"] = "socket::reconnectionTimedOut";
    ChatEvents["SocketDataIncomingEvent"] = "socket::data";
    ChatEvents["ChatAuthSuccessEvent"] = "chat::authSuccess";
    ChatEvents["ChatAuthFailureEvent"] = "chat::authFailed";
    ChatEvents["RoomJoinedEvent"] = "room::joined";
    ChatEvents["RoomJoinCompletedEvent"] = "room::joinCompleted";
    ChatEvents["RoomResolvedEvent"] = "room::resolved";
    ChatEvents["RoomLeftEvent"] = "room::left";
    ChatEvents["RoomKickedOutEvent"] = "room::kicked";
    ChatEvents["RoomDeletedEvent"] = "room::deleted";
    ChatEvents["RoomRenamedEvent"] = "room::renamed";
    ChatEvents["RoomParticipantAddedEvent"] = "room::participantAdded";
    ChatEvents["RoomTextMessageReceivedEvent"] = "room::text";
    ChatEvents["RoomTextMessageDeliveredEvent"] = "message::delivered";
    ChatEvents["RoomTextMessageReadEvent"] = "message::read";
    ChatEvents["RoomTextMessageMarkedReadEvent"] = "message::markedRead";
    ChatEvents["RoomTextMessageReactedEvent"] = "message::reacted";
    ChatEvents["MessageHistoryFetched"] = "message::historyFetched";
    ChatEvents["RoomTypingEvent"] = "room::typingEvent";
    ChatEvents["CallInProgress"] = "call::progress";
    ChatEvents["CallRinging"] = "call::ringing";
    ChatEvents["CallEstablished"] = "call::established";
    ChatEvents["CallJoinMediaRoom"] = "call::joinMediaRoom";
    ChatEvents["CallFailed"] = "call::failed";
    ChatEvents["CallEnded"] = "call::ended";
    ChatEvents["CallMediaCheck"] = "call::mediaCheck";
    ChatEvents["CallDisconnected"] = "call::disconnected";
    ChatEvents["CallLeftByUser"] = "call::leftByUser";
    ChatEvents["CallDeclinedByUser"] = "call::declinedByUser";
})(ChatEvents || (ChatEvents = {}));
